window.addEventListener('DOMContentLoaded', () => {
  const deviceTracks = [
    {
      track: document.querySelector('.device-track.-track-1'),
      initialX: 210,
      initialY: 0,
      finalX: 220,
      finalY: -5
    },
    {
      track: document.querySelector('.device-track.-track-2'),
      initialX: 70,
      initialY: -40,
      finalX: 65,
      finalY: -35
    },
    {
      track: document.querySelector('.device-track.-track-3'),
      initialX: 380,
      initialY: -80,
      finalX: 390,
      finalY: -85
    }
  ]

  const updateTracksScroll = () => {
    const percent = Math.max(window.scrollY, 50) / 50.0

    deviceTracks.forEach(({ track, initialX, initialY, finalX, finalY }) => {
      if (track) {
        track.style.top = `${initialY + (finalY - initialY) * percent}px`
        track.style.left = `${initialX + (finalX - initialX) * percent}px`
      }
    })
  }

  window.addEventListener('scroll', () => updateTracksScroll())
  updateTracksScroll()
})
